export default {"src":"/_next/static/media/Group 588.58888b52.svg","height":659,"width":702,"blurWidth":0,"blurHeight":0};